export const travelTypes = ['insurance', 'transfer', 'handling', 'railAndFly', 'excursion'];
